import { render, staticRenderFns } from "./UnitMargin.vue?vue&type=template&id=2fa32782&"
import script from "./UnitMargin.vue?vue&type=script&lang=ts&"
export * from "./UnitMargin.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2fa32782')) {
      api.createRecord('2fa32782', component.options)
    } else {
      api.reload('2fa32782', component.options)
    }
    module.hot.accept("./UnitMargin.vue?vue&type=template&id=2fa32782&", function () {
      api.rerender('2fa32782', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sales/reports/UnitMargin.vue"
export default component.exports